// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"ResetPasswordPage_pageWrap__eq6bA","formDescription":"ResetPasswordPage_formDescription__1HK_Z","highlighted":"ResetPasswordPage_highlighted__1zC7L"};